import React, { Fragment } from 'react'
import { useRelatedNews, RelatedNewsProps } from './useRelatedNews'
import TitleSection from 'components/TitleSection/TitleSection'
import NewsCard from 'components/NewsCard/NewsCard'
import Tab from 'components/Tab/Tab'
import styles from './RelatedNews.module.scss'

const RelatedNews: React.FC<RelatedNewsProps> = (props: RelatedNewsProps) => {
  const {
    isAr,
    selectedLanguage,
    newsByTags,
    departmentRelatedTags,
    activeTabId,
    t,
    handleTagClick,
  } = useRelatedNews(props)

  return (
    <section className={styles['related-news']}>
      <TitleSection title={t('relatedNews')} />
      <div className='container py-5'>
        <div className={styles['related-tags-tabs-container']}>
          {departmentRelatedTags && departmentRelatedTags.length ? (
            departmentRelatedTags.map((tag, index) => (
              <Tab
                id={tag.id}
                name={isAr ? tag.tagAr : tag.tagEn}
                isActive={
                  (index === 0 && !activeTabId) || tag.id === activeTabId
                }
                key={`tag-${tag.id}`}
                handleClick={handleTagClick}
              />
            ))
          ) : (
            <Fragment />
          )}
        </div>
        <div className='row'>
          {newsByTags && newsByTags.length ? (
            newsByTags.map((news, index) => {
              const description = isAr ? news.descriptionAr : news.descriptionEn
              let shortDescription = ''

              if (
                description &&
                description.length > 0 &&
                description[0].children &&
                description[0].children.length > 0
              ) {
                const firstText = description[0].children[0].text
                shortDescription = `${firstText.substring(0, 100)}...`
              } else shortDescription = t('noDetails')

              return (
                <div
                  key={`news-${news.id}-${index}`}
                  className='col-12 col-md-6 col-lg-4 mb-3'
                  data-tags-ids={news.tags.map((tag) => tag.id).join(',')}
                >
                  <NewsCard
                    image={news.image}
                    title={isAr ? news.titleAr : news.titleEn}
                    description={shortDescription}
                    author={isAr ? news.author.nameAr : news.author.nameEn}
                    authorImage={news.author.photo}
                    category={
                      isAr ? news.category.nameAr : news.category.nameEn
                    }
                    url={`/${selectedLanguage}/NewsDetails/${news.slugAr}`}
                    date={news.publishedAt.split('T')[0]}
                    isAr={isAr}
                    t={t}
                  />
                </div>
              )
            })
          ) : (
            <div
              className={`col-12 text-center ${styles['no-data']} fs-4 fw-bold`}
            >
              {t('noData')}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default RelatedNews
